import React from 'react'

import moment from 'moment'
import { addKeyToObjectsArray } from 'utils/addUniqueKeyToObjects'

import { reportError } from 'utils/errorReporter'
import styles from '../styles'

const BuildRestrictions = (props) => {
  const { restrictionsData } = props
  const classes = styles()
  
  try {
    return (
      <div className={classes.expansibleContent}>
        {restrictionsData.consists ? (
          restrictionsData.restrictions.map((restriction) => {
            return (
              <React.Fragment key={`restriction:${restriction.uuid}`}>
                <p>
                  <strong>{restriction.list_name}</strong>
                </p>

                <div className={classes.restrictions}>
                  <span>
                    <b>Nome: </b>
                    {restriction.subject_name}
                  </span>

                  <span>
                    <b>Pseudônimo(s): </b>
                    {restriction.pseudonyms ? (
                      <p>
                        <ul>
                          {addKeyToObjectsArray(restriction.pseudonyms.map(pseudonym => { return { name: pseudonym } })).map((pseudonym) => {
                            return (
                              <li key={pseudonym.key}>{pseudonym.name}</li>
                            )
                          })}
                        </ul>
                      </p>
                    ) : (
                      'N/A'
                    )}
                  </span>

                  <span>
                    <b>Data da Entrada: </b>
                    {moment(restriction.entry_date).format('DD/MM/YYYY')}
                  </span>

                  <span>
                    <b>Data da Saída: </b>
                    {restriction.exit_date ? moment(restriction.exit_date).format('DD/MM/YYYY') : 'permanece na lista restritiva'}
                  </span>
                </div>
              </React.Fragment>
            )
          })
        ) : (
          <div className={classes.expansibleContent}>
            <span>Nenhum registro encontrado.</span>
          </div>
        )}
      </div>
    )
  } catch (err) {
    reportError(err)
    return (
      <div className={classes.errorCaptured}>
        <span>Ocorreu um erro ao tratar os dados</span>
      </div>
    )
  }
}

export default BuildRestrictions
